import Vue from 'vue'
let vm = new Vue();

import axiosJava from '../utils/java-https.js'
import config from '../utils/config.js'//黄耿智：2023-01-10
import {
	Message,MessageBox
} from 'element-ui';

export default {
  // 访问本地文件
  // 需要先进行映射
  img(url){
  	if(!url){
  		return url;
  	}
  	url = url.replaceAll("\\","/");
  	if(url.indexOf("http") == 0){
  		return url;
  	}
  	
  	let transUrl = url;
  	return config.baseUrl() + transUrl;
  },
  textToCode(TextToCode,info){
    let tmpList = [];
    let provinceResult = TextToCode[info.province];
    //console.log("provinceResult",provinceResult);
    if(provinceResult && provinceResult.code){
    	tmpList.push(provinceResult.code);
    }
    if(provinceResult){
    	let cityResult = TextToCode[info.province][info.city];
    	//console.log("cityResult",cityResult);
    	if(cityResult && cityResult.code){
    		tmpList.push(cityResult.code);
    	}

    	if(cityResult){
    		let countryResult = TextToCode[info.province][info.city][info.district];
    		//console.log("countryResult",countryResult);
    		if(countryResult && countryResult.code){
    			tmpList.push(countryResult.code);
    		}
    	}
    }

    return tmpList;
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js